export const DROP_DOWN_MENU_POSITION_TOP_LEFT = 'top left';
export const DROP_DOWN_MENU_POSITION_TOP_CENTER = 'top center';
export const DROP_DOWN_MENU_POSITION_TOP_RIGHT = 'top right';
export const DROP_DOWN_MENU_POSITION_BOTTOM_LEFT = 'bottom left';
export const DROP_DOWN_MENU_POSITION_BOTTOM_CENTER = 'bottom center';
export const DROP_DOWN_MENU_POSITION_BOTTOM_RIGHT = 'bottom right';
export const DROP_DOWN_MENU_POSITION_BOTTOM_LEFT_EDGE = 'bottom left-edge';
export const DROP_DOWN_MENU_POSITION_BOTTOM_RIGHT_EDGE = 'bottom right-edge';
